import * as React from 'react';
import Methods from '../ApiCalls/apiMethods';
import { Grid, Icon, Page } from 'tabler-react';
import { useAPI } from '../ApiCalls/useAPI';
import { useHistory } from 'react-router-dom';
// import '../App.css';
const SANJAYA = '/sanjaya-web';

class HomePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            postId: null,
            session: null,            
        };                
    }
    checkResponse(data) {
        // console.log(data, 'a1');
        this.setState({ data: data });               
    }
    componentDidMount() {    
        const { getHomepagedata } = useAPI();
        getHomepagedata()
        .then((response) => this.checkResponse(response))
        .catch((error) => console.error(error));
        
    }
    handleClick = () => {
        let rollno = localStorage.getItem('rollno');
        // Redirect to the specified URL when the card is clicked
        window.location.href = Methods.global_url + '/sanjaya/getPerformance.php?id='+rollno;
    }

    
   
    // const [data, setData] = useState([]);        
    
    render() {
      
        let psflag = localStorage.getItem('psflag');   
        let a1, a2, b, c, d;
        if (this.state.data != null) {
            // if(psflag == 1)
            // {
            //     a2 = (
            //         <PSAttendanceCard
            //             data={this.state.data.attendance}
            //             history={this.props.history}
            //         />
            //     );                
            // }
            // else{
            //     a1 = (
            //         <AttendanceCard
            //             data={this.state.data.attendance}
            //             history={this.props.history}
            //         />
            //     );
            // }
            // b = (
            //     <PerformanceCard
            //         data={this.state.data.performance}
            //         history={this.props.history}
            //     />
            // );
            // c = (
            //     <DisciplineCard
            //         data={this.state.data.points}
            //         history={this.props.history}
            //     ></DisciplineCard>
            // );
            // d = (
            //     <SonetCard
            //         data={this.state.data.sonet}
            //         history={this.props.history}
            //     ></SonetCard>
            // );
        } else {
            a1 = null;
            a2 = null;
            b = null;
        }
        return (
            <Page.Content title="Dashboard">
                <div id="fullview">
                    <Grid.Row cards={true}>
                        {
                            psflag == 1 ?
                            <Grid.Col xs={12} sm={4} lg={4} width={6}>
                                {a2}
                            </Grid.Col>
                            :
                            <Grid.Col xs={12} sm={4} lg={4} width={6}>
                                {a1}
                            </Grid.Col>
                        }                                                
                        <Grid.Col xs={12} sm={4} lg={4} width={6}>
                            {b}
                        </Grid.Col>
                        <Grid.Col xs={12} sm={4} lg={4} width={6}>
                            {c}
                        </Grid.Col>
                    </Grid.Row>
                </div>
                <div id="mobview">
                    <Grid.Row cards={true}>
                        {
                            psflag == 1 ?
                            <Grid.Col width={12}>{a2}</Grid.Col>
                            :
                            <Grid.Col width={12}>{a1}</Grid.Col>
                        }
                    </Grid.Row>
                    <Grid.Row cards={true}>
                        <Grid.Col width={6}>{b}</Grid.Col>
                        <Grid.Col width={6}>{c}</Grid.Col>
                    </Grid.Row>
                </div>

                <Grid.Row cards={true}>
                    {/* {
                        psflag == 1 ?
                        <Grid.Col width={6} sm={4} lg={2}>
                            <a style={{ textDecoration: 'none' }} href={SANJAYA + "/psattendance"}>
                                <div className="card">
                                    <div className="card-body p-3 text-center">
                                        <div className="text-green text-right"></div>
                                        <div className="h1 m-0">
                                            <i className="fe fe-check"></i>
                                        </div>
                                        <div className=" ">Attendance</div>
                                    </div>
                                </div>
                            </a>
                        </Grid.Col>
                        :
                        <Grid.Col width={6} sm={4} lg={2}>
                            <a style={{ textDecoration: 'none' }} href={SANJAYA + "/attendance"}>
                                <div className="card">
                                    <div className="card-body p-3 text-center">
                                        <div className="text-green text-right"></div>
                                        <div className="h1 m-0">
                                            <i className="fe fe-check"></i>
                                        </div>
                                        <div className="  ">Attendance</div>
                                    </div>
                                </div>
                            </a>
                        </Grid.Col>
                    } */}
                    
                    <Grid.Col width={6} sm={4} lg={2}>
                        <div className="card" onClick={this.handleClick} style={{cursor: 'pointer',color: '#6896d7'}}>
                            <div className="card-body p-3 text-center">
                                <div className="text-green text-right" />
                                <div className="h1 m-0">
                                    <i className="fe fe-target" />
                                </div>
                                <div className=" ">Performance</div>
                            </div>
                        </div>
                    </Grid.Col>
                    <Grid.Col width={6} sm={4} lg={2}>
                        <a style={{ textDecoration: 'none' }} href={SANJAYA + "/results"}>
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right" />
                                    <div className="h1 m-0">
                                    <i className="fe fe-clipboard" />
                                    </div>
                                    <div className="  ">Results</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>
                    {/* <Grid.Col width={6} sm={4} lg={2}>
                        <a
                            style={{ textDecoration: 'none' }}
                            href={SANJAYA + "/noticeboard"}
                        >
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right" />
                                    <div className="h1 m-0">
                                        <i className="fe fe-bell" />
                                    </div>
                                    <div className="  ">Notice Board</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col> */}
                    {/* <Grid.Col width={6} sm={4} lg={2}>
                        <a style={{ textDecoration: 'none' }} href={SANJAYA + "/sonet"}>
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right" />
                                    <div className="h1 m-0">
                                        <i className="fe fe-code"></i>
                                    </div>
                                    <div className="  ">SONET</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>  */}
                    {/* <Grid.Col width={6} sm={4} lg={2}>
                        <a style={{ textDecoration: 'none' }} href={SANJAYA + "/arjuna"}>
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right" />
                                    <div className="h1 m-0">
                                        <i className="fe fe-anchor" />
                                    </div>
                                    <div className="  ">Arjuna</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col> */}
                    {/* <Grid.Col width={6} sm={4} lg={2}>
                        <a style={{ textDecoration: 'none' }} href={SANJAYA + "/timetable"}>
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right"></div>
                                    <div className="h1 m-0">
                                        <i className="fe fe-clock"></i>
                                    </div>
                                    <div className="  ">Time Table</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col> */}
                    {/* <Grid.Col width={6} sm={4} lg={2}>
                        <a
                            style={{ textDecoration: 'none' }}
                            href={SANJAYA + "/discipline"}
                        >
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right" />
                                    <div className="h1 m-0">
                                        <i className="fe fe-flag" />
                                    </div>
                                    <div className="  ">Discipline</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col> */}
                    <Grid.Col width={6} sm={4} lg={2}>
                        <a style={{ textDecoration: 'none' }} href={SANJAYA + "/events"}>
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right"></div>
                                    <div className="h1 m-0">
                                        <i className="fe fe-calendar"></i>
                                    </div>
                                    <div className="  ">Events</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>
                    {/* <Grid.Col width={6} sm={4} lg={2}>
                        <a style={{ textDecoration: 'none' }} href={SANJAYA + "/results"}>
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right" />
                                    <div className="h1 m-0">
                                        <i className="fe fe-clipboard" />
                                    </div>
                                    <div className="  ">Results</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col> */}
                    <Grid.Col width={6} sm={4} lg={2}>
                        <a style={{ textDecoration: 'none' }} href={SANJAYA + "/contact"}>
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right" />
                                    <div className="h1 m-0">
                                        <i className="fe fe-phone" />
                                    </div>
                                    <div className="  ">Contact KSJC</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>
                    <Grid.Col width={6} sm={4} lg={2}>
                        <a
                            style={{ textDecoration: 'none' }}
                            href={SANJAYA + "/studentdiary"}
                        >
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right"></div>
                                    <div className="h1 m-0">
                                        <i className="fe fe-book"></i>
                                    </div>
                                    <div className="  ">Student Diary</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>
                    <Grid.Col width={6} sm={4} lg={2}>
                        <a
                            style={{ textDecoration: 'none' }}
                            href={SANJAYA + "/complaints"}
                        >
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right"></div>
                                    <div className="h1 m-0">
                                        <i className="fe fe-file-text"></i>
                                    </div>
                                    <div className="  ">Complaints</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>
                    <Grid.Col width={6} sm={4} lg={2}>
                        <a
                            style={{ textDecoration: 'none' }}
                            href={SANJAYA + "/appointment"}
                        >
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right"></div>
                                    <div className="h1 m-0">
                                        <i className="fe fe-file-text"></i>
                                    </div>
                                    <div className="  ">Schedule Appointment</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>

                    <Grid.Col width={6} sm={4} lg={2}>
                        <a
                            style={{ textDecoration: 'none' }}
                            href={SANJAYA + "/liveclassroom"}
                        >
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right"></div>
                                    <div className="h1 m-0">
                                        <i className="fe fe-play"></i>
                                    </div>
                                    <div className="  ">LiveClassroom</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>
                    <Grid.Col width={6} sm={4} lg={2}>
                        <a
                            style={{ textDecoration: 'none' }}
                            href={SANJAYA + "/groupchange"}
                        >
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right"></div>
                                    <div className="h1 m-0">
                                        <i className="fe fe-file-text"></i>
                                    </div>
                                    <div className="  ">Group Change Request</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>
                    {/* <Grid.Col width={6} sm={4} lg={2}>
                        <a style={{ textDecoration: 'none' }} href="https://kmit.in/assets/college/docs/BE-Rules-Regulations-E2020-21-22-03-21.pdf" target="_blank">
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right" />
                                    <div className="h1 m-0">
                                        <i className="fe fe-book" />
                                    </div>
                                    <div className="  ">
                                        Rules and Regulations
                                    </div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col> */}
                    <Grid.Col width={6} sm={4} lg={2}>
                        <a style={{ textDecoration: 'none' }} href={SANJAYA + "/settings"}>
                            <div className="card">
                                <div className="card-body p-3 text-center">
                                    <div className="text-green text-right"></div>
                                    <div className="h1 m-0">
                                        <i className="fe fe-settings"></i>
                                    </div>
                                    <div className="">Settings</div>
                                </div>
                            </div>
                        </a>
                    </Grid.Col>
                </Grid.Row>
            </Page.Content>
        );
    }
}

class AttendanceCard extends React.Component {
    render() {
        // console.log(this.props.data, '&$$');
        if (this.props.data) {
            return (
                <div
                    className="card overviewcard"
                    style={{ padding: '10px' }}
                    onClick={() => this.props.history.push('attendance')}
                >
                    <div>
                        <h5>
                            <Icon prefix="fe" name="check"></Icon> Attendance
                        </h5>
                    </div>
                    <div>
                        <DayAttendance
                            data={this.props.data.sessions.session1}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session2}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session3}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session4}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session5}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session6}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session7}
                        />
                        <div>{this.props.data.updatedon}</div>
                    </div>
                </div>
            );
        } else {
            // console.log(this.props, '%');
            return <div>No attendance.</div>;
        }
    }
}

class PSAttendanceCard extends React.Component {
    render() {
        // console.log(this.props.data, '&$$');
        if (this.props.data) {
            return (
                <div
                    className="card overviewcard"
                    style={{ padding: '10px' }}
                    onClick={() => this.props.history.push('psattendance')}
                >
                    <div>
                        <h5>
                            <Icon prefix="fe" name="check"></Icon> Attendance
                        </h5>
                    </div>
                    <div>
                        <DayAttendance
                            data={this.props.data.sessions.session1}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session2}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session3}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session4}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session5}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session6}
                        />
                        <DayAttendance
                            data={this.props.data.sessions.session7}
                        />
                        <div>{this.props.data.date}</div>
                    </div>
                </div>
            );
        } else {
            // console.log(this.props, '%');
            return <div>No attendance.</div>;
        }
    }
}

class DayAttendance extends React.Component {
    render() {
        // console.log(this.props.data)
        switch (this.props.data) {
            case '0':
                return (
                    <Icon prefix="fe" name="x-circle" className="red"></Icon>
                );
            case '1':
                return (
                    <Icon
                        prefix="fe"
                        name="check-circle"
                        className="green"
                    ></Icon>
                );
            case '2':
                return <Icon prefix="fe" name="circle"></Icon>;

            default:
                return <Icon prefix="fe" name="circle"></Icon>;
        }
    }
}
class PerformanceCard extends React.Component {
    render() {
        let a;
        if (this.props.data) {
            a = this.props.data;
        } else {
            a = null;
        }
        // console.log(a, 'a');
        return (
            <div
                className="card overviewcard"
                style={{ padding: '10px' }}
                onClick={() => this.props.history.push('performance')}
            >
                <div>
                    <h5>
                        <Icon prefix="fe" name="target"></Icon> Performance
                    </h5>
                </div>
                <div>
                    <h5 style={{ marginBottom: '0px' }}>{a.aggpercentage}</h5>
                    {a.updatedon}
                </div>
            </div>
        );
    }
}
// class SonetCard extends React.Component {
//     render() {
//         let a;
//         if (this.props.data) {
//             a = this.props.data;
//         } else {
//             a = null;
//         }
//         // console.log(a, 'a');
//         return (
//             <div
//                 className="card overviewcard"
//                 style={{ padding: '10px' }}
//                 onClick={() => this.props.history.push('sonet')}
//             >
//                 <div>
//                     <h5>
//                         <Icon prefix="fe" name="code"></Icon> SONET
//                     </h5>
//                 </div>
//                 <div>
//                     <h5 style={{ marginBottom: '0px' }}>
//                         <span style={{ fontWeight: 'bold', fontSize: '120%' }}>
//                             {a.att}
//                         </span>
//                     </h5>
//                     {a.updatedon}
//                 </div>
//             </div>
//         );
//     }
// }
class DisciplineCard extends React.Component {
    render() {
        let a;
        if (this.props.data) {
            a = this.props.data;
        } else {
            a = null;
        }
        // console.log(a, 'a');
        return (
            <div
                className="card overviewcard"
                style={{ padding: '10px' }}
                onClick={() => this.props.history.push('discipline')}
            >
                <div>
                    <h5>
                        <Icon prefix="fe" name="flag" /> Discipline
                    </h5>
                </div>
                <div>
                    <h5 style={{ marginBottom: '0px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '120%' }}>
                            {a.score}
                        </span>{' '}
                        of {a.maxscore}{' '}
                    </h5>

                    {a.updatedon}
                </div>
            </div>
        );
    }
}
export default HomePage;